<template>
    <overlay class="sitemap-overlay" v-if="isShown">
        <div class="container">
            <nav class="sitemap">
                <ul class="row no-gutters">
                    <li class="col col-view col-view-ruyi">
                        <router-link class="sitemap-link sitemap-link-primary" :to="{ name: `${$i18n.locale}.ruyi` }">{{ $t('pages.ruyi.title') }}</router-link>
                        <ul class="row no-gutters">
                            <li class="col col-subview">
                                <a class="sitemap-link sitemap-link-secondary" :href="$t('links.company-value.url')">{{ $t('links.company-value.title') }}</a>
                                <ul class="row no-gutters">
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.company-value__our-philosophy.url')">{{ $t('links.company-value__our-philosophy.title') }}</a>
                                    </li>
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.company-value__confucian-roots.url')">{{ $t('links.company-value__confucian-roots.title') }}</a>
                                    </li>
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.company-value__our-staff.url')">{{ $t('links.company-value__our-staff.title') }}</a>
                                    </li>
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.company-value__chairman-message.url')">{{ $t('links.company-value__chairman-message.title') }}</a>
                                    </li>
                                </ul>
                            </li>
                            <li class="col col-subview">
                                <a class="sitemap-link sitemap-link-secondary" :href="$t('links.talents.url')">{{ $t('links.talents.title') }}</a>
                                <ul class="row no-gutters">
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.talents__recruitment.url')">{{ $t('links.talents__recruitment.title') }}</a>
                                    </li>
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.talents__talent-development.url')">{{ $t('links.talents__talent-development.title') }}</a>
                                    </li>
                                </ul>
                            </li>
                            <li class="col col-subview">
                                <a class="sitemap-link sitemap-link-secondary" :href="$t('links.social-responsibility.url')">{{ $t('links.social-responsibility.title') }}</a>
                                <ul class="row no-gutters">
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.social-responsibility__ruyi-cares.url')">{{ $t('links.social-responsibility__ruyi-cares.title') }}</a>
                                    </li>
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.social-responsibility__ruyi-cares.url')">{{ $t('links.social-responsibility__sustainability.title') }}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li class="col col-view col-view-technology">
                        <router-link class="sitemap-link sitemap-link-primary" :to="{ name: `${$i18n.locale}.technology` }">{{ $t('pages.technology.title') }}</router-link>
                        <ul class="row no-gutters">
                            <li class="col col-subview">
                                <a class="sitemap-link sitemap-link-secondary" :href="$t('links.rd.url')">{{ $t('links.rd.title') }}</a>
                                <ul class="row no-gutters">
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.rd__awards-recognitions.url')">{{ $t('links.rd__awards-recognitions.title') }}</a>
                                    </li>
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.rd__ruyi-technology-research-institute.url')">{{ $t('links.rd__ruyi-technology-research-institute.title') }}</a>
                                    </li>
                                </ul>
                            </li>
                            <li class="col col-subview">
                                <a class="sitemap-link sitemap-link-secondary" :href="$t('links.intelligent-manufacturing.url')">{{ $t('links.intelligent-manufacturing.title') }}</a>
                                <ul class="row no-gutters">
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.intelligent-manufacturing__eco-textile-spinning-weaving.url')">{{ $t('links.intelligent-manufacturing__eco-textile-spinning-weaving.title') }}</a>
                                    </li>
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.intelligent-manufacturing__intelligent-equipment.url')">{{ $t('links.intelligent-manufacturing__intelligent-equipment.title') }}</a>
                                    </li>
                                </ul>
                            </li>
                            <li class="col col-subview">
                                <a class="sitemap-link sitemap-link-secondary" :href="$t('links.global-presence.url')">{{ $t('links.global-presence.title') }}</a>
                                <ul class="row no-gutters">
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.global-presence__textile-in-china.url')">{{ $t('links.global-presence__textile-in-china.title') }}</a>
                                    </li>
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.global-presence__milestones.url')">{{ $t('links.global-presence__milestones.title') }}</a>
                                    </li>
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.global-presence__ruyis_companies.url')">{{ $t('links.global-presence__ruyis_companies.title') }}</a>
                                    </li>
                                    <li class="col col-view-section d-md-none"></li>
                                </ul>
                            </li>
                            <li class="col col-subview">
                                <a class="sitemap-link sitemap-link-secondary" :href="$t('links.vertical-integration.url')">{{ $t('links.vertical-integration.title') }}</a>
                                <ul class="row no-gutters">
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.vertical-integration__whole-wool-spinning-industry-chain.url')">{{ $t('links.vertical-integration__whole-wool-spinning-industry-chain.title') }}</a>
                                    </li>
                                    <li class="col col-subview-section">
                                        <a class="sitemap-link" :href="$t('links.vertical-integration__whole-cotton-spinning-industry-chain.url')">{{ $t('links.vertical-integration__whole-cotton-spinning-industry-chain.title') }}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li class="col col-view col-view-fashion">
                        <router-link class="sitemap-link sitemap-link-primary" :to="{ name: `${$i18n.locale}.fashion` }">{{ $t('pages.fashion.title') }}</router-link>
                        <ul class="row no-gutters">
                            <li class="col col-view-section">
                                <router-link class="sitemap-link" :to="{ name: `${$i18n.locale}.fashion`, hash: '#ruyi-brand-network' }">{{ $t('pages.fashion.text-block-01.title') }}</router-link>
                            </li>
                            <li class="col col-view-section">
                                <router-link class="sitemap-link" :to="{ name: `${$i18n.locale}.fashion`, hash: '#smcp' }">SMCP</router-link>
                            </li>
                            <li class="col col-view-section">
                                <router-link class="sitemap-link" :to="{ name: `${$i18n.locale}.fashion`, hash: '#renown' }">RENOWN</router-link>
                            </li>
                            <li class="col col-view-section d-md-none"></li>
                        </ul>
                    </li>
                    <li class="col col-view col-view-sustainability">
                        <router-link class="sitemap-link sitemap-link-primary" :to="{ name: `${$i18n.locale}.sustainability` }">{{ $t('pages.sustainability.title') }}</router-link>
                        <ul class="row no-gutters">
                            <li class="col col-view-section">
                                <router-link class="sitemap-link" :to="{ name: `${$i18n.locale}.sustainability`, hash: '#green-energy' }">{{ $t('pages.sustainability.text-block-01.title') }}</router-link>
                            </li>
                            <li class="col col-view-section">
                                <router-link class="sitemap-link" :to="{ name: `${$i18n.locale}.sustainability`, hash: '#powering-future' }">{{ $t('pages.sustainability.text-block-02.title') }}</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="col col-view">
                        <a class="sitemap-link sitemap-link-primary" :href="$t('links.ruyi-news.url')">{{ $t('links.ruyi-news.title') }}</a>
                        <a class="sitemap-link sitemap-link-primary" :href="$t('links.contact.url')">{{ $t('links.contact.title') }}</a>
                    </li>
                </ul>
            </nav>
        </div>
    </overlay>
</template>

<script>
  import { mapState } from 'vuex'

  import Overlay from './Overlay'

  export default {
    computed: {
      ...mapState({
        isShown: (state) => state.overlays.sitemap.isShown
      })
    },
    components: {
      Overlay
    }
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .sitemap-overlay {
        background-color: rgba(255, 255, 255, 0.95);

        @include media-breakpoint-up(md) {
            background-color: rgba(245, 245, 245, 0.95);
        }

        .container {
            padding-left: 0;
            padding-right: 0;

            @include media-breakpoint-up(md) {
                padding-left: 15px;
                padding-right: 15px;
            }
        }
    }

    .sitemap {
        color: #7a7a7a;
        font-size: px2rem(15px);
        text-align: center;

        @include media-breakpoint-up(md) {
            font-size: px2rem(12px);
            margin-bottom: px2rem(60px);
            margin-top: px2rem(60px);
            text-align: left;
        }

        @include media-breakpoint-up(xl) {
            font-size: px2rem(15px);
            margin-bottom: px2rem(120px);
            margin-top: px2rem(120px);
        }

        .row {
            margin: 0;
            padding: 0;
            list-style: none;
        }

        .col {

            &-view {
                flex-basis: 100%;

                @include media-breakpoint-up(md) {
                    border-left: 1px solid #7a7a7a;
                    flex-basis: 20%;
                    max-width: 20%;
                    padding-left: 1rem !important;
                    padding-right: 1rem !important;
                }

                &-section {
                    border-bottom: 1px solid #ebebeb;
                    flex-basis: 50%;
                    max-width: 50%;

                    &:nth-child(2n+1) {
                        border-right: 1px solid #ebebeb;
                    }

                    @include media-breakpoint-up(md) {
                        border: none !important;
                        flex-basis: 100%;
                        margin-bottom: 1rem;
                        max-width: none;
                    }
                }
            }

            &-subview {
                flex-basis: 100%;

                @include media-breakpoint-up(md) {
                    margin-bottom: 2rem;
                }

                &-section {
                    border-bottom: 1px solid #ebebeb;
                    flex-basis: 50%;
                    max-width: 50%;

                    &:nth-child(2n+1) {
                        border-right: 1px solid #ebebeb;
                    }

                    @include media-breakpoint-up(md) {
                        border: none !important;
                        flex-basis: 100%;
                        margin-left: 1em;
                        max-width: none;
                    }

                    &::before {
                        @include media-breakpoint-up(md) {
                            content: ' - ';
                            float: left;
                            margin-left: -1em;
                        }
                    }
                }
            }
        }

        &-link {
            color: inherit;
            display: block;
            padding: 0.5rem;

            @include media-breakpoint-up(md) {
                padding: 0;
            }

            &-primary {
                border-bottom: 1px solid #ebebeb;
                color: $black;

                @include media-breakpoint-up(md) {
                    font-size: px2rem(15px);
                    border-bottom: none;
                    margin-bottom: 1rem;
                }

                @include media-breakpoint-up(xl) {
                    font-size: px2rem(18px);
                }
            }

            &-secondary {
                border-bottom: 1px solid #ebebeb;

                @include media-breakpoint-up(md) {
                    border-bottom: none;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// SitemapOverlay.vue?02e2cf55